var U = Object.defineProperty, A = Object.defineProperties;
var L = Object.getOwnPropertyDescriptors;
var g = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
var b = (r, t, o) => t in r ? U(r, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[t] = o, i = (r, t) => {
  for (var o in t || (t = {}))
    y.call(t, o) && b(r, o, t[o]);
  if (g)
    for (var o of g(t))
      R.call(t, o) && b(r, o, t[o]);
  return r;
}, p = (r, t) => A(r, L(t));
var C = (r, t) => {
  var o = {};
  for (var e in r)
    y.call(r, e) && t.indexOf(e) < 0 && (o[e] = r[e]);
  if (r != null && g)
    for (var e of g(r))
      t.indexOf(e) < 0 && R.call(r, e) && (o[e] = r[e]);
  return o;
};
import v, { forwardRef as S, useState as T, useEffect as D } from "react";
import { jsx as x } from "react/jsx-runtime";
import { u as _ } from "./DirectionProvider-CT8S13Cp.js";
import { a as $ } from "./floating-ui.react-DiT1zkFi.js";
import { u as m } from "./use-reduced-motion-C9DbPZfj.js";
function J(r) {
  var o;
  const t = v.version;
  return typeof v.version != "string" || t.startsWith("18.") ? r == null ? void 0 : r.ref : (o = r == null ? void 0 : r.props) == null ? void 0 : o.ref;
}
function K(r, t) {
  if (r === "rtl" && (t.includes("right") || t.includes("left"))) {
    const [o, e] = t.split("-"), n = o === "right" ? "left" : "right";
    return e === void 0 ? n : `${n}-${e}`;
  }
  return t;
}
function F(r, t, o, e) {
  return r === "center" || e === "center" ? { top: t } : r === "end" ? { bottom: o } : r === "start" ? { top: o } : {};
}
function P(r, t, o, e, n) {
  return r === "center" || e === "center" ? { left: t } : r === "end" ? { [n === "ltr" ? "right" : "left"]: o } : r === "start" ? { [n === "ltr" ? "left" : "right"]: o } : {};
}
const j = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function E({
  position: r,
  arrowSize: t,
  arrowOffset: o,
  arrowRadius: e,
  arrowPosition: n,
  arrowX: u,
  arrowY: a,
  dir: l
}) {
  const [s, f = "center"] = r.split("-"), d = {
    width: t,
    height: t,
    transform: "rotate(45deg)",
    position: "absolute",
    [j[s]]: e
  }, c = -t / 2;
  return s === "left" ? p(i(i({}, d), F(f, a, o, n)), {
    right: c,
    borderLeftColor: "transparent",
    borderBottomColor: "transparent",
    clipPath: "polygon(100% 0, 0 0, 100% 100%)"
  }) : s === "right" ? p(i(i({}, d), F(f, a, o, n)), {
    left: c,
    borderRightColor: "transparent",
    borderTopColor: "transparent",
    clipPath: "polygon(0 100%, 0 0, 100% 100%)"
  }) : s === "top" ? p(i(i({}, d), P(f, u, o, n, l)), {
    bottom: c,
    borderTopColor: "transparent",
    borderLeftColor: "transparent",
    clipPath: "polygon(0 100%, 100% 100%, 100% 0)"
  }) : s === "bottom" ? p(i(i({}, d), P(f, u, o, n, l)), {
    top: c,
    borderBottomColor: "transparent",
    borderRightColor: "transparent",
    clipPath: "polygon(0 100%, 0 0, 100% 0)"
  }) : {};
}
const N = S(
  (c, d) => {
    var h = c, {
      position: r,
      arrowSize: t,
      arrowOffset: o,
      arrowRadius: e,
      arrowPosition: n,
      visible: u,
      arrowX: a,
      arrowY: l,
      style: s
    } = h, f = C(h, [
      "position",
      "arrowSize",
      "arrowOffset",
      "arrowRadius",
      "arrowPosition",
      "visible",
      "arrowX",
      "arrowY",
      "style"
    ]);
    const { dir: B } = _();
    return u ? /* @__PURE__ */ x(
      "div",
      p(i({}, f), {
        ref: d,
        style: i(i({}, s), E({
          position: r,
          arrowSize: t,
          arrowOffset: o,
          arrowRadius: e,
          arrowPosition: n,
          dir: B,
          arrowX: a,
          arrowY: l
        }))
      })
    ) : null;
  }
);
N.displayName = "@mantine/core/FloatingArrow";
function M({
  opened: r,
  floating: t,
  position: o,
  positionDependencies: e
}) {
  const [n, u] = T(0);
  D(() => {
    if (t.refs.reference.current && t.refs.floating.current && r)
      return $(
        t.refs.reference.current,
        t.refs.floating.current,
        t.update
      );
  }, [
    t.refs.reference.current,
    t.refs.floating.current,
    r,
    n,
    o
  ]), m(() => {
    t.update();
  }, e), m(() => {
    u((a) => a + 1);
  }, [r]);
}
export {
  N as F,
  K as a,
  J as g,
  M as u
};
